exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dataUpload .ant-modal-body {\n  padding: 30px 24px;\n}\n.dataUpload .ant-steps-label-vertical .ant-steps-item-content {\n  width: 104px;\n}\n.dataUpload-steps {\n  display: none;\n  margin-top: 20px;\n  text-align: center;\n}\n.dataUpload-steps.is-show {\n  display: block;\n}\n.dataUpload .ant-alert-banner {\n  margin-top: -20px;\n}\n.dataUpload .ant-steps {\n  margin-top: 20px;\n}\n", ""]);

// exports
